// @ts-check
import { create } from '@storybook/theming'

export const storybookDarkTheme = create({
  base: 'dark',
  appBg: '#020D1F',
  barBg: '#132134',
  appContentBg: '#15212C',
})
